import { useState } from "react";

const faqs = [
  {
    question: "Quel est le délai moyen pour réparer une fenêtre à Illkirch ?",
    answer:
      "À Illkirch-Graffenstaden, la proximité avec notre atelier de Strasbourg nous permet d'intervenir très rapidement. Pour une urgence, comptez 2 à 4 heures. Pour une réparation planifiée, nous vous proposons un créneau sous 24 heures. Le déplacement et le diagnostic sont gratuits, et le devis est détaillé avant toute intervention.",
  },
  {
    question: "Intervenez-vous dans les résidences étudiantes et les immeubles ?",
    answer:
      "Oui, absolument. Illkirch compte des résidences universitaires, des immeubles collectifs et des quartiers pavillonnaires. Nos techniciens sont formés pour intervenir dans tous les contextes, du studio au pavillon. Nous réparons toutes les marques de quincaillerie et tous les types de fenêtres : PVC, aluminium, bois. Chaque pièce remplacée est garantie 10 ans.",
  },
  {
    question: "Comment se passe le paiement après une intervention ?",
    answer:
      "Le technicien établit un devis écrit avant de commencer. Vous l'acceptez ou non, sans aucune pression. Si vous acceptez, l'intervention se déroule sur place et le paiement se fait à l'issue des travaux. Pas d'avance, pas de frais cachés. Le déplacement est gratuit, le devis est gratuit, et la pièce de remplacement est comprise dans le prix.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Questions fréquentes — Illkirch-Graffenstaden
          </h2>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="bg-rose-50 rounded-2xl border border-rose-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                  >
                    <span className="font-semibold text-base md:text-lg text-plum-dark">
                      {faq.question}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center shrink-0">
                      <i className={`ri-${isOpen ? "subtract" : "add"}-line text-plum`} />
                    </div>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6">
                      <p className="text-sm md:text-base text-plum-dark/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}